var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-apex-charts',{attrs:{"options":_vm.chartOptions,"series":_vm.series,"height":_vm.height},on:{"dataPointSelection":_vm.emitClickSection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }